import './App.css';
import { useEffect, useState, MouseEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Select, { components, ActionMeta } from 'react-select'
import { fetchUser, updateUser, fetchUsers, registerUser } from './features/user/userSlice'
import { fetchOrganizations } from './features/organizations/organizationSlice'
import AdminHeader from './AdminHeader';
import { User, SelectedOption, NewUserInfo } from './Classes1';
import { IUser, ISelectedOption } from './interfaces';
import type { RootState, AppDispatch } from './store'
import { useAppSelector } from './app/hooks'
import {parseJwt} from "./helpers/helperFunctions";

export type AdminProps = {
    test: string
  };

  interface OrgItem { 
    orgId: string,
    orgName: string
  }
  
  const Admin: React.FC<AdminProps> = ({ test }) => {

    const { accessToken } = useAppSelector((state: RootState) => state.auth)
    const [showEye, setShowEye] = useState<string>('');
    const [hideEye, setHideEye] = useState<string>('show');
    const [passwordType, setPasswordType] = useState<string>('password');
    const [newUser, setNewUser] = useState<boolean>(false);
    let [loginLoader, setLoginLoader] = useState<string>('');
    const [userInfo, setUserInfo] = useState<IUser>(new User())
    const [users, setUsers] = useState<IUser[]>([])
    const [user, setUser] = useState<IUser>(new User())
    const [password, setPassword] = useState<string>('')
    let [selectedOption, setSelectedOption] = useState<ISelectedOption | null>(new SelectedOption({}))

    const [emailError, setEmailError] = useState<boolean>(false);
    const [passwordError, setPasswordError] = useState<boolean>(false);
    const [firstNameError, setFirstNameError] = useState<boolean>(false);
    const [lastNameError, setLastNameError] = useState<boolean>(false);
    const [rankError, setRankError] = useState<boolean>(false);
    const [saveSuccess, setSaveSuccess] = useState<string>('');
    const [saveMessage, setSaveMessage] = useState<string>('');
    const [orgOptions, setOrgOptions] = useState<ISelectedOption[] | null>([]);

    const CustomDropdownIndicator = (props: any) => {
        return (
          <components.DropdownIndicator {...props}>
            <img src="img/chevron-down-grey.svg" className={`chevron-down-grey`} alt="arrow" />
          </components.DropdownIndicator>
        );
      };

      const dropdownStyles = {
        option: (provided: any, { isFocused, isSelected } : { isFocused: any, isSelected: any }) => ({
            ...provided,
            backgroundColor: isFocused ? "#009BF9" : "#FFF",
            fontSize: 14,
            color: "#161616",
            paddingLeft: 20
        }),
        singleValue: (provided: any, state: any) => ({
            ...provided,
            padding: 0,
            color: '#161616',
            backgroundColor: "#FFF",
            width: 288,
            fontSize: 14,
            paddingLeft: 10
        }),
        container:  (provided: any, state: any) => ({
            ...provided,
            border: "none",
            width: 288,
            height: 50
        }),
        control:  (provided: any, state: any) => ({
            ...provided,
            backgroundColor: "#FFF",
            color: "#161616",
            borderRadius: 0,
            border: "none",
            boxShadow: 0,
            width: 288,
            height: 52
        }),
        placeholder:  (provided: any, state: any) => ({
            ...provided,
            color: "#161616",
            fontSize: 14
        }),
        indicatorSeparator:  (provided: any, state: any) => ({
            ...provided,
            display: "none"
        }),
        menu:  (provided: any, state: any) => ({
            ...provided,
            width: 288,
            color: '#161616',
            backgroundColor: "#FFF",
            top: 50
        }),
        input:  (provided: any, state: any) => ({
            ...provided,
            marginTop: 5,
            height: 37
        }),
        menuList:  (provided: any, state: any) => ({
            ...provided,
            color: '#161616',
            backgroundColor: "#FFF",
            paddingTop: 0,
            paddingBottom: 0,
        }),
        indicatorContainer:  (provided: any, state: any) => ({
            ...provided,
            color: '#161616'
        })
    }

    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate()

    useEffect(() => {
        const getUserInfo = async (id: string) => {
            let user = await dispatch(fetchUser(id))
            
            const newOrgs: OrgItem[] = [{ orgId: '1', orgName: 'Test Org 1' }, { orgId: '2', orgName: 'Test Org 2' }]

            let orgName: string = ''
            for (let i = 0; i<newOrgs.length; i++) {
                if (user.payload.orgId === newOrgs[i].orgId) {
                    orgName = newOrgs[i].orgName
                }
            }
            setSelectedOption({ label: orgName, value: user.payload.orgId })
            setUser(user.payload)
            setUserInfo(user.payload)
            if (user.payload.admin) {
                getUsers()
            }
            
        }

        const getUsers = async () => {
            let users: any = await dispatch(fetchUsers())
            const newUsers = JSON.parse(JSON.stringify(users.payload))
            for (let i = 0; i<newUsers.length; i++) {
                newUsers[i].selected = ''
            }
            newUsers[0].selected = 'selected'
            setUserInfo(newUsers[0])
            setUsers(newUsers)
        }

        if (accessToken) {
            let parsedJWT = parseJwt(accessToken)
            getUserInfo(parsedJWT.id)
            
        } else {
            navigate('/login')
        }

      }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        async function asyncCall() {
            let orgs: any = await dispatch(fetchOrganizations())
            let orgOpts: ISelectedOption[] = [];
            for (let i = 0; i<orgs.payload.length; i++) {
                let orgOpt: ISelectedOption = { label: orgs.payload[i].orgName, value: orgs.payload[i].id }
                orgOpts.push(orgOpt)
            }
            setOrgOptions(orgOpts)
        }
        asyncCall()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const saveForm = async () => {
        
        setLoginLoader('login-loader')

        if (userInfo.firstName === '') {
            setFirstNameError(true)
        } else {
            setFirstNameError(false)
        }

        if (userInfo.lastName === '') {
            setLastNameError(true)
        } else {
            setLastNameError(false)
        }

        if (userInfo.rank === '') {
            setRankError(true)
        } else {
            setRankError(false)
        }

        if (newUser) {
            if (userInfo.email === '') {
                setEmailError(true)
            } else {
                setEmailError(false)
            }

            if (userInfo.password === '') {
                setPasswordError(true)
            } else {
                setPasswordError(false)
            }
        }

        if (newUser) {
            if (userInfo.email !== '' && userInfo.password !== '' && userInfo.firstName !== '' && userInfo.lastName !== '' && userInfo.rank !== '') {
                let newUserInfo = new NewUserInfo()

                newUserInfo.userID = userInfo.email;
                newUserInfo.password = password;
                newUserInfo.firstName = userInfo.firstName;
                newUserInfo.lastName = userInfo.lastName;
                newUserInfo.rank = userInfo.rank;
                newUserInfo.orgId = userInfo.orgId;
                newUserInfo.admin = userInfo.admin;

                const registerUserResp: any = await dispatch(registerUser(newUserInfo))

                if (registerUserResp.error !== undefined) {
                    setSaveSuccess('failed')
                    setSaveMessage("failed")
                } else if (registerUserResp.meta.requestStatus === 'fulfilled') {
                    setSaveSuccess('success')
                    setSaveMessage('success')
                }

                setUserInfo(new User())

                let users: any = await dispatch(fetchUsers())
                const newUsers = JSON.parse(JSON.stringify(users.payload))
                setUsers(newUsers)
                setPassword('')
            }
        } else {
            if (userInfo.firstName !== '' && userInfo.lastName !== '' && userInfo.rank !== '') {
                const updateUserResp: any = await dispatch(updateUser(userInfo))
                if (updateUserResp.error !== undefined) {
                    setSaveSuccess('failed')
                    setSaveMessage("failed")
                } else {
                    setSaveSuccess('success')
                    setSaveMessage("success")
                }

                setUserInfo(updateUserResp.payload)
            }
        }

        setTimeout(() => {
            setSaveSuccess('')
            setSaveMessage('')
        }, 3000);
        
        setLoginLoader('')
    }

    const onChangeAdmin = async () => {
        setUserInfo({
            ...userInfo, 
            admin: !userInfo.admin
        });
    }

    const onChangeEmail = (ev: React.ChangeEvent<HTMLInputElement>) => {
        const target = ev.currentTarget as HTMLInputElement;
        
        if (target) {
            setUserInfo({
                ...userInfo, 
                email: target.value
            });
        }
    }

    const onChangePassword = (ev: React.ChangeEvent<HTMLInputElement>) => {
        const target = ev.currentTarget as HTMLInputElement;
        
        if (target) {
            setPassword(target.value)
            setUserInfo({
                ...userInfo, 
                password: target.value
            });
        }
    }

    const onChangeFirstName = (ev: React.ChangeEvent<HTMLInputElement>) => {
        const target = ev.currentTarget as HTMLInputElement;
        
        if (target) {
            setUserInfo({
                ...userInfo, 
                firstName: target.value
            });
        }
    }

    const onChangeLastName = (ev: React.ChangeEvent<HTMLInputElement>) => {
        const target = ev.currentTarget as HTMLInputElement;
        
        if (target) {
            setUserInfo({
                ...userInfo, 
                lastName: target.value
            });
        }
    }

    const onChangeRank = (ev: React.ChangeEvent<HTMLInputElement>) => {
        const target = ev.currentTarget as HTMLInputElement;
        
        if (target) {
            setUserInfo({
                ...userInfo, 
                rank: target.value
            });
        }
    }

    const clickUser = (ev: MouseEvent) => {
        const target = ev.currentTarget as HTMLInputElement;
        
        if (target) {
            const newUsers = JSON.parse(JSON.stringify(users));

            for (let i = 0; i<newUsers.length; i++) {
                newUsers[i].selected = ''
            }

            for (let i = 0; i<newUsers.length; i++) {
                if (newUsers[i].email === target.dataset.email) {
                    newUsers[i].selected = 'selected'
                    setUserInfo(newUsers[i])
                }
            }

            setUsers(newUsers)
        }
    }

    const handleChange = async (selectedOption: ISelectedOption | null, actionMeta: ActionMeta<ISelectedOption>) => {
        setSelectedOption(selectedOption);

        setUserInfo({
            ...userInfo, 
            orgId: selectedOption!.value
        });
    }

    const togglePassword = (ev: MouseEvent) => {
        const target = ev.currentTarget as HTMLInputElement;
        
        if (target) {
            if (target.dataset.pass === 'show') {
                setShowEye('')
                setHideEye('show')
                setPasswordType('password')
            } else {
                setShowEye('show')
                setHideEye('')
                setPasswordType('text')
            }
        }
    }

    const onChangeNewUser = (ev: React.ChangeEvent<HTMLInputElement>) => {
        setNewUser(!newUser)

        if (!newUser) {
            // update userInfo
            let newUserInfo = new User();
            newUserInfo.email = '';
            newUserInfo.password = '';
            newUserInfo.firstName = '';
            newUserInfo.lastName = '';
            newUserInfo.rank = '';
            newUserInfo.orgId = '1';

            setUserInfo(newUserInfo);
        }
    }

    return (
        <>
        <AdminHeader />
        <div className="login-page">
            <div className={`admin-page-content ${!user.admin ? 'non-admin' : ''}`}>
                {user.admin ? <div className="admin-page-list">
                    <div className="login-title">Users</div>
                    <div className="user-list">
                        <div className="user-list-wrapper">
                            <div className="user-list-inner">
                                {users.map((user: User, i: number) => {
                                    return (<div className={`user-list-item ${user.selected}`} key={i} onClick={clickUser} data-email={user.email}>
                                        <div className="user-list-item-title">{user.email}</div>
                                        <div className="user-list-item-text">
                                            <div className="user-list-item-datetime">test</div>
                                            <div className="user-list-item-details">3 Participants (Inst, A-2, A-3)</div>
                                        </div>
                                    </div>)
                                })}
                            </div>
                        </div>
                    </div>
                </div> : <div className="admin-page-list"></div> }
                <div className="admin-page-form">
                    <div className="login-title">User</div>
                    { user.admin ? <><div className="new-user-label">New User</div>
                    <div className="checkbox-wrapper-12 new-user-checkbox">
                        <input className="tgl tgl-ios" id="cb2-12" type="checkbox" value={newUser.toString()} checked={newUser} onChange={onChangeNewUser} />
                        <label className="tgl-btn" htmlFor="cb2-12"></label>
                    </div></> : <></> }

                    { !newUser ? <div className='form-group'>
                        <label htmlFor="form-input" className="admin-form-label">Email</label>
                        <div className="admin-form-email">{userInfo.email}</div>
                    </div> : <></> }

                    { newUser ? <div className='form-group'>
                        { emailError ? <div className="admin-form-error">Email Required</div> : <></> }
                        <label htmlFor="form-input" className="admin-form-label">Email</label>
                        <input
                            type='text'
                            placeholder='Email'
                            className='form-input'
                            value={userInfo.email}
                            onChange={onChangeEmail}
                            required
                        />
                    </div> : <></> }
                    
                    <div className='form-group'>
                        { passwordError ? <div className="admin-form-error">Password Required</div> : <></> }
                        <label htmlFor="form-input" className="admin-form-label">Password</label>
                        <input
                            type={passwordType}
                            placeholder='Password'
                            className='form-input'
                            value={password}
                            onChange={onChangePassword}
                            required
                        />
                        <img src="img/eye.svg" className={`password-eye ${showEye}`} onClick={togglePassword} alt="eye" data-pass="show" />
                        <img src="img/eye-slash.svg" className={`password-eye-slash ${hideEye}`} onClick={togglePassword} alt="eye" data-pass="hide" />
                    </div>
                    <div className='form-group'>
                        { firstNameError ? <div className="admin-form-error">First Name Required</div> : <></> }
                        <label htmlFor="form-input" className="admin-form-label">First Name</label>
                        <input
                            type='text'
                            placeholder='First Name'
                            className='form-input'
                            value={userInfo.firstName}
                            onChange={onChangeFirstName}
                            required
                        />
                    </div>
                    <div className='form-group'>
                        { lastNameError ? <div className="admin-form-error">Last Name Required</div> : <></> }
                        <label htmlFor="form-input" className="admin-form-label">Last Name</label>
                        <input
                            type='text'
                            placeholder='Last Name'
                            className='form-input'
                            value={userInfo.lastName}
                            onChange={onChangeLastName}
                            required
                        />
                    </div>
                    <div className='form-group'>
                        { rankError ? <div className="admin-form-error">Rank Required</div> : <></> }
                        <label htmlFor="form-input" className="admin-form-label">Rank</label>
                        <input
                            type='text'
                            placeholder='Rank'
                            className='form-input'
                            value={userInfo.rank}
                            onChange={onChangeRank}
                            required
                        />
                    </div>
            
                    <div className='form-group'>
                        <label htmlFor="form-input" className="admin-form-label">Organization</label>
                        <Select
                            value={{ label: selectedOption!.label, value: selectedOption!.value }}
                            onChange={handleChange}
                            components={{ DropdownIndicator: CustomDropdownIndicator }}
                            options={orgOptions!}
                            styles={dropdownStyles}
                            className={'org-select'}
                            data-id="select1"
                        /> 
                    </div>
                    
                    { user.admin ? <><label htmlFor="form-input" className="admin-form-label">Admin</label>
                    <div className="checkbox-wrapper-11 admin-checkbox">
                        <input className="tgl tgl-ios" id="cb2-11" type="checkbox" value={userInfo.admin.toString()} checked={userInfo.admin} onChange={onChangeAdmin} />
                        <label className="tgl-btn" htmlFor="cb2-11"></label>
                    </div></> : <></> }
                    <button className={`sign-in-btn ${saveSuccess}`} onClick={saveForm}>
                        <span className="sign-in-text">Save {saveMessage}</span>
                        <div className={`loader ${loginLoader}`}></div>
                    </button>
                </div>
            </div>
        </div>
        </>
    )

  }

  export default Admin;